import React, { useState } from "react";
import styles from "./Webform.module.css";
import { Button } from "@mui/material";
import CreateFormPopup from "./CreateFormPopup/CreateFormPopup";

function WelcomeWebForm(props: any) {
  const {
    CreateWebform,
    CreateWebformSuccess,
    CreateWebformId,
    hasWebformsAccess,
  } = props;
  const [showCreateFormPopup, setShowCreateFormPopup] = useState(false);

  const handleCreateNewClick = () => {
    setShowCreateFormPopup(true);
  };

  return (
    <div
      style={{
        borderRadius: "4px",
        border: "1px solid #E1E1E1",
        background: "#FFF",
        padding: "30px 90px",
      }}
    >
      <div style={{ textAlign: "center", maxWidth: "690px", margin: "0 auto" }}>
        <div className={styles.welcomeHead}>
          Welcome to nurture's Webform Builder
        </div>
        <div className={styles.welcomePara}>
          Your ultimate tool for collecting valuable data and engaging with your
          audience effortlessly. Create, customize, and manage webforms with
          ease, all within nurture.
        </div>
        {hasWebformsAccess && (
          <Button
            variant="contained"
            sx={{ textTransform: "capitalize" }}
            onClick={handleCreateNewClick}
            disabled={hasWebformsAccess === false}
          >
            Create New
          </Button>
        )}
      </div>
      {showCreateFormPopup && (
        <CreateFormPopup
          CreateWebform={CreateWebform}
          CreateWebformSuccess={CreateWebformSuccess}
          CreateWebformId={CreateWebformId}
          isOpen={showCreateFormPopup}
          onClose={() => setShowCreateFormPopup(false)}
        />
      )}
    </div>
  );
}

export default WelcomeWebForm;
